import createVueComponent from '../createVueComponent';

const Diff = createVueComponent('DiffIcon', [
  ['path', { d: 'M12 3v14', key: '7cf3v8' }],
  ['path', { d: 'M5 10h14', key: 'elsbfy' }],
  ['path', { d: 'M5 21h14', key: '11awu3' }],
]);

export default Diff;
